import { DateRangeCalendar } from 'components/DateRangePicker'
import { Button, Dropdown, Search , useKeyEvent} from 'monday-ui-react-core'
import React, { useMemo, useState } from 'react'
import { Col } from 'react-bootstrap'
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons'
import './PayoutAllStatements.scss'
import { Usertype } from 'utils/Constants'

export default function PayoutAllStatementsForm({
    showAdvancedSearch,
    setShowAdvancedSearch,
    setSelectedStatus,
    setSelectedStatementType,
    handleSearchChange,
    handleSearchSubmit,
    setSelectedStatementDates,
    type,
    isUnreadFiltered,
    onTabChange,
    statementDateFrom,
    statementDateTo
}) {
    const [isSearchFocused, setIsSearchFocused] = useState(false)

    useKeyEvent({
        keys: ["Enter"],
        // @ts-ignore
        callback: e => onEnterPressed(e.key)
    });

    const onEnterPressed = (keyName) => {
        if(keyName === 'Enter' && isSearchFocused){
            handleSearchSubmit()
            setIsSearchFocused(true)
        }
    }

    const options = useMemo(
        () => [
            {
                value: 1,
                label: 'All statements',
            },
            {
                value: 2,
                label: 'Current & past',
            },
            {
                value: 3,
                label: 'Current only',
            }
        ],
        []
    )

    const optionsSender = useMemo(
        () => [
            {
                value: 1,
                label: 'All statements',
            },
            {
                value: 2,
                label: 'Current & past',
            },
            {
                value: 3,
                label: 'Current only',
            },
            { 
                value: 4,
                label: 'Hidden only',
            }
        ],
        []
    )

    const statementTypeOptions = useMemo(
        () => [
            {
                value: 0,
                label: 'All statements',
            },
            {
                value: 1,
                label: 'Accounting Date',
            },
            {
                value: 2,
                label: 'Activity Date',
            },
        ],
        []
    )

    const handleTabClick = (isUnread) => {
        isUnreadFiltered.current = isUnread
        onTabChange()
    }

    return (
        <>
            <Col sm={12} lg={2} className="mt-3">
                <span className="fw-bold statement-status">
                    Statement Status
                </span>
                <Dropdown
                    placeholder="Status"
                    size={Dropdown.size.SMALL}
                    options={(type === Usertype.SENDER ? optionsSender : options)}
                    onChange={setSelectedStatus}
                    clearable={false}
                    className="status-picker w-100"
                    defaultValue={[options[0]]}
                />
                {
                    type === Usertype.RECEIVER && (
                        <div className="d-flex pt-2 pb-2">
                            <p className={`all-statements-inner-tab ${!isUnreadFiltered.current && "active"}`}
                                onClick={() =>
                                    handleTabClick(false)
                                }
                            >
                                All
                            </p>
                            <p className={`all-statements-inner-tab ${isUnreadFiltered.current && "active"}`}
                                onClick={() =>
                                    handleTabClick(true)
                                }
                            >
                                Unread
                            </p>
                        </div>
                    )
                }
            </Col>
            <Col sm={12} lg={4} className="mt-3">
                <span className="fw-bold statement-date">Statement Date</span>
                <DateRangeCalendar onChange={setSelectedStatementDates} from={statementDateFrom} to={statementDateTo}
                />
            </Col>
            <Col sm={12} lg={2} className="mt-3">
                <span className="fw-bold statement-type">
                    Statement Type
                </span>
                <Dropdown
                    placeholder="Statement Type"
                    size={Dropdown.size.SMALL}
                    options={statementTypeOptions}
                    onChange={setSelectedStatementType}
                    clearable={false}
                    className="status-picker w-100"
                    defaultValue={[options[0]]}
                />
            </Col>
            <Col sm={12} lg={4} className="mt-3">
                <span className="search-container">Search</span>
                <div className="d-flex">
                    <Search id="searchbar"
                        placeholder="Search"
                        size={Search.sizes.SMALL}
                        onChange={handleSearchChange}
                        className="payout-search"
                        onBlur={() => setIsSearchFocused(false)}
                        onFocus={() => setIsSearchFocused(true)}
                    />
                    <Button
                        size={Button.sizes.SMALL}
                        type={Button.types.SUBMIT}
                        onClick={handleSearchSubmit}
                        className="payout-search-button"
                    >
                        Search
                    </Button>
                </div>
                <div className="d-flex flex-row-reverse pt-2 pb-2">
                    <p
                        className="down-arrow-search-text"
                        onClick={() =>
                            setShowAdvancedSearch(!showAdvancedSearch)
                        }
                    >
                        Advanced Search
                        {showAdvancedSearch ? (
                            <CaretUpFill className="payout-icon" size={15} />
                        ) : (
                            <CaretDownFill className="payout-icon" size={15} />
                        )}
                    </p>
                </div>
            </Col>
        </>
    )
}
